import { Injectable } from '@angular/core';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';

import { environment } from '../../environments/environment';
import { Account } from '../helpers/auth';

import { ApiService } from './api.service';

@Injectable({
    providedIn: 'root'
})
export class AuthService {

    private account: Account = null;

    constructor(
        private activatedRoute: ActivatedRoute,
        private apiService: ApiService,
        private router: Router,
    ) { }

    /**
     * User account.
     */
    getAccount(): Account {
        return this.account;
    }

    /**
     * Authorization token.
     */
    getToken(): string {
        return localStorage.getItem(environment.authStorage);
    }

    /**
     * Initializes service.
     */
    async init(): Promise<void> {
        const paramMap: ParamMap = this.activatedRoute.snapshot.queryParamMap;
        const urlToken: string = paramMap.get(environment.authUrlParam);

        if (urlToken) {
            this.storeToken(urlToken);

            const cleanUrl: string = this.router.url.split('?')[0];
            this.router.navigateByUrl(cleanUrl);
        }

        const token: string = this.getToken();

        if (token) {
            return this.apiService.get(`${environment.apiUrl}${environment.accountApi}me/`).then((account: Account) => {
                this.account = account;
            }).catch(() => {});
        }
    }

    /**
     * Checks if user authorized.
     */
    isAuthorized(): boolean {
        return Boolean(this.account);
    }

    /**
     * Redirects user to the login page.
     */
    login(): void {
        const redirectParam: string = encodeURIComponent(location.href);
        location.href = `${environment.apiUrl}${environment.authPath}${redirectParam}`;
    }

    /**
     * Logs user out and reloads page to re-init app.
     */
    async logout(): Promise<void> {
        this.account = null;
        localStorage.removeItem(environment.authStorage);

        await this.apiService.get(`${environment.apiUrl}${environment.accountApi}logout/`);
        location.reload();
    }

    /**
     * Stores auth token in local storage.
     * @param token Auth token string.
     */
    private storeToken(token: string): void {
        localStorage.setItem(environment.authStorage, token);
    }
}
